// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoseCategoryChips_wrapper__3iawH","item":"PoseCategoryChips_item__EP3_u"};